import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export const ReservationStatusSchema = z.union([
  z.literal(0), // NotReserved
  z.literal(1), // ReservationInProgress
  z.literal(2), // FullyReserved
  z.literal(3), // ReservationFailed
])

export const ReservationFailureReasonSchema = z
  .union([
    z.literal(0), // InsufficientInventory
    z.literal(1), // SystemError
    z.literal(2), // ValidationError
    z.literal(3), // InventoryLocked
    z.literal(4), // MaxRetryExceeded
  ])
  .nullable()

export const ReservedLotSchema = z.object({
  lotNo: z.string(),
  lotDate: z.coerce.date(),
  qty: z.number(),
  reservedAt: z.coerce.date(),
})

export const Sale1010SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
    partyId: z.string().optional(),
    itemId: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)
export type Sale1010SearchParams = z.infer<typeof Sale1010SearchParamsSchema>

export const Sale1010SearchResultModelSchema = z.object({
  id: z.number(),
  number: z.string(),
  date: z.coerce.date(),
  deliveryDate: z.coerce.date(),
  partyId: z.number().nullable(),
  itemId: z.number().nullable(),
  qty: z.number(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
  reservationStatus: ReservationStatusSchema,
})

export type Sale1010SearchResultModel = z.infer<
  typeof Sale1010SearchResultModelSchema
>

export const Sale1010SearchResultSchema = z
  .object({
    data: z.array(Sale1010SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Sale1010SearchResult = z.infer<typeof Sale1010SearchResultSchema>
